import React, { useEffect, useRef } from 'react';
import { View, StyleSheet, Dimensions, Animated, TouchableOpacity, Text } from 'react-native';
import Header from './Header';
import Sidebar from './Sidebar';

const CalculatorLayout = ({ children, isSidebarOpen, onToggleSidebar, onCloseSidebar }) => {
  // Get screen dimensions for responsive behavior
  const screenWidth = Dimensions.get('window').width;
  const isMobile = screenWidth < 768;
  const sidebarWidth = 320; // matches Sidebar default
  const translateX = useRef(new Animated.Value(isSidebarOpen ? 0 : -sidebarWidth)).current;
  const pulse = useRef(new Animated.Value(1)).current;

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'column',
    },
    mainContent: {
      flex: 1,
      flexDirection: 'row',
    },
    content: {
      flex: 1,
    },
    sidebarWrapper: {
      width: sidebarWidth,
      zIndex: 2,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.08,
      shadowRadius: 6,
      elevation: 2,
    },
    showHandle: {
      position: 'absolute',
      left: 0,
      top: 90,
      paddingVertical: 10,
      paddingHorizontal: 12,
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
      backgroundColor: '#e5e7eb',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    handleText: { fontSize: 12, color: '#111827', fontWeight: '600' },
  });

  useEffect(() => {
    Animated.timing(translateX, {
      toValue: isSidebarOpen ? 0 : -sidebarWidth,
      duration: 220,
      useNativeDriver: true,
    }).start();
  }, [isSidebarOpen, translateX]);

  useEffect(() => {
    const loop = Animated.loop(
      Animated.sequence([
        Animated.timing(pulse, { toValue: 1.08, duration: 700, useNativeDriver: true }),
        Animated.timing(pulse, { toValue: 1, duration: 700, useNativeDriver: true }),
      ])
    );
    loop.start();
    return () => loop.stop();
  }, [pulse]);

  return (
    <View style={styles.container}>
      <Header onMenuPress={onToggleSidebar} />
      <View style={styles.mainContent}>
        {!isMobile && (
          <Animated.View
            pointerEvents={isSidebarOpen ? 'auto' : 'none'}
            style={[
              styles.sidebarWrapper,
              {
                width: isSidebarOpen ? sidebarWidth : 0,
                transform: [{ translateX }],
              },
            ]}
          >
            <Sidebar isOpen={true} onClose={onCloseSidebar} />
          </Animated.View>
        )}
        {isMobile && <Sidebar isOpen={isSidebarOpen} onClose={onCloseSidebar} />}
        <View style={styles.content}>
          {children}
        </View>
        {!isMobile && !isSidebarOpen && (
          <Animated.View style={[styles.showHandle, { transform: [{ scale: pulse }] }]}>
            <TouchableOpacity onPress={onToggleSidebar}>
              <Text style={styles.handleText}>Show Menu ▶</Text>
            </TouchableOpacity>
          </Animated.View>
        )}
      </View>
    </View>
  );
};

export default CalculatorLayout;